module.exports = __webpack_public_path__ + "static/media/noActivity.9be85ad3.svg";